export const CONTACTS_VALUES = {
  phones: {
    // main_old: {
    //   value: '+74955266574',
    //   text: '+7 (495) 526-65-74',
    //   adds: '300',
    // },
    main: {
      value: '+74956202000',
      smi: '+74956202000,39779',
      extensions: [
        {
          code: '39779',
          label: 'для вопросов по экспортной поддержке',
        },
        {
          code: '39787',
          label: 'по общим вопросам',
        },
        {
          code: '39792',
          label: 'по вопросам HR (вакансии, практика, стажировки)',
        },
      ],
    },
  },
  emails: {
    main: {
      value: 'info@prom.moscow',
      text: 'info@prom.moscow',
    },
    smi: {
      value: 'pr@prom.moscow',
      text: 'pr@prom.moscow',
    },
  },
  addrs: {
    // main_old: {
    //   postal: '125009',
    //   contry: 'Россия',
    //   city: 'г. Москва',
    //   street: 'Большой Кисловский переулок, дом 6',
    // },
    main: {
      postal: '123112',
      contry: 'Россия',
      city: 'г. Москва',
      street: 'Пресненская набережная, д. 8 стр. 1',
    },
  },
};
